import { SubSink } from 'subsink';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { StateType } from '@monorepo/ui';

import { LoadingType } from '@monorepo/ui';
import { ALOGLIA_CONFIG } from '../../../shared/constants';
@Component({
  selector: 'signgaze-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
})
export class MapViewComponent implements OnInit {
  readonly subs = new SubSink();
  position = 'bottom';
  readonly alogliaConfig: any = {
    ...ALOGLIA_CONFIG,
  };
  readonly defaultSearchParameters = {
    hitsPerPage: 12,
    clickAnalytics: true,
  };

  StateTypeEnum: any = StateType;
  LoadingTypeEnum: any = LoadingType;
  toggleModalVisibility = false;
  searchParameters: any = {
    ...this.defaultSearchParameters,
  };
  facetCategory: string;
  facetValue: string;
  isCheckedMap = false;
  isShowMap = false;
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.buildSearchParameters();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public updateStatusById(isChecked: boolean): void {
    this.isCheckedMap = isChecked;
    if (this.isCheckedMap === true) {
      this.isShowMap = true;
    } else {
      this.isShowMap = false;
    }
  }

  private buildSearchParameters(): void {
    this.route.queryParams.subscribe((params) => {
      if (Object.keys(params)[0]) {
        this.facetCategory = Object.keys(params)[0];
        this.facetValue = decodeURI(Object.values(params)[0]);
        this.searchParameters = {
          ...this.searchParameters,
          facetFilters: [`${this.facetCategory}:${this.facetValue}`],
        };
      } else {
        this.facetCategory = null;
        this.facetValue = null;
        this.searchParameters = {
          ...this.defaultSearchParameters,
        };
      }
    });
  }
}
